/**
 *  @desc 路由配置项
 *  @return { Object } constantRouterMap 无需认证即可访问的路由页面，router初始化时即注册
 *  @return { Object } asyncRouterMap 动态注册的路由，需要进行身份验证后或根据权限动态的注册
 *  @return.default { Object } router vue-router实例
 *  @author
 *  @lastUpdate
 */

import Vue from 'vue';
import Router from 'vue-router';
import NProgress from 'nprogress';
import store from '../store';
// import constantRouterMap from './constantsRouterMap';
import beforeEach from './beforeEach';
// 自己加的静态路由
import Layout from '../views/components/mainLayout/Layout.vue';
// import newAddRouter from './newAddRouter';
import console from './routes/console';
import system from './routes/system';
import { SET_CONTENT_CLASS } from '../store/mutationTypes';

Vue.use(Router);

// match '/' to Router setting
// 登录后的默认访问页面

// 自动导入asyncMap
// const requireAll = requireContext => requireContext.keys().map(requireContext);
// const req = require.context('./asyncMap', true, /\.js$/);
// let asyncRouterMap = []; //eslint-disable-line
// requireAll(req).map((md) => {
//     asyncRouterMap.push(md.default);
// });

/**
 * @desc asyncMap/*.js 路由参数配置解释
 * 该目录存放需要经过验证后才能访问的路由页面，并且在其App.vue下<router-view></router-view>区域渲染
 *
 * 配置项： 默认值
 * hidden: false                  如果hidden为true，则不会在菜单显示该路由
 * alwaysShow: false              如果alwaysShow为true，则始终会显示根菜单，与子路由数量无关。
 *                                如何alwaysShow设置为false，当根路由下只有一个子路由时，根路由会变成最近的一个子路由而不会显示根路由
 * name:'RouterName'              name为路由唯一标记，作为路由跳转或提供keep-alive功能识别，其name请保持和组件内name一直 (must set!!!).
 * meta : {
    title: 'title'                在菜单栏显示的名字
    icon: 'svg-name'              当有icon时，会在菜单上显示，icon对应src/icons/svg/下.svg文件名
    roles: ['admin', 'other']     路由所对应的可访问的角色
  }
 */
// 报错Navigating to current location ("/rights/) not allowed
// 在路由跳转的时候同一个路由多次添加时不被允许的。重写路由push方法

// const VueRouterPush = Router.prototype.push;
// Router.prototype.push = function push(to) {
//   return VueRouterPush.call(this, to).catch((err) => err);
// };
// // 解决重复路由引起的错误
// const originalReplace = Router.prototype.replace;
// Router.prototype.replace = function replace(location) {
//   return originalReplace.call(this, location).catch((err) => err);
// };

// export {
//   constantRouterMap, newAddRouter,
// };

const router = new Router({
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    // ...constantRouterMap,
    { path: '/', redirect: '/console/home' },
    { path: '/home', redirect: '/console/home' },
    {
      path: '/404',
      name: '404',
      meta: {
        auth: 0,
      },
      component: () => import('../views/error-page/404.vue'),
    },
    {
      path: '/401',
      name: '401',
      meta: {
        auth: 0,
      },
      component: () => import('../views/error-page/401.vue'),
    },
    {
      path: '/console/',
      component: Layout,
      children: [...console],
    },
    {
      path: '/system/',
      component: Layout,
      children: [...system],
    },
  ],
});

beforeEach.forEach((item) => {
  router.beforeEach(item);
});

// router.afterEach(() => {
//   setTimeout(() => {
//     const contentDom = document.querySelector('.ud-content');
//     if (contentDom) {
//       const bodySrcollTop = contentDom.scrollTop;
//       if (bodySrcollTop !== 0) {
//         contentDom.scrollTop = 0;
//       }
//     }
//   }, 16);

//   // 结束Progress
//   NProgress.done();
// });

// 路由切换成功
router.afterEach((route) => {
  const meta = route.meta || {};
  // document.title = meta.title || '';
  document.body.className = meta.backgroundClass || '';
  store.commit(SET_CONTENT_CLASS, meta.contentClass || 'bg-white');
  // store.commit(SET_TITLE, meta.title || '');
  // console.log('s');
  // console.log(route);
  /* setTimeout(()=>{
    Toast(false);
  },200); */
  // 结束Progress
  NProgress.done();
});

export default router;
